module.exports = __webpack_public_path__ + "static/media/refresh.b97028e8.svg";